
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/genes/[slug]",
      function () {
        return require("private-next-pages/genes/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/genes/[slug]"])
      });
    }
  